import React, { useState } from "react";
import Modal from "./Modal";
import Button from "../Button/Button";
import Text from "../Text/Text";
import { Col, Row } from "antd";
import image from "../../resource/image";

interface Props {
  visible: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

function ModalCheckQuotaDup({ visible, onCancel, onSubmit }: Props) {
  return (
    <Modal visible={visible} onCancel={onCancel} maskClosable={false} width={380}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "0px 0px 22px 0px",
        }}
      >
        <img src={image.warning_product_quota} style={{ marginBottom: 22 }} />
        <Text align='center' fontWeight={700} fontSize={24}>
          ไม่สามารถเปิดใช้งานโควตาได้
        </Text>
        <Text
          align='center'
          fontWeight={400}
          fontSize={16}
          color='background4'
          fontFamily='Sarabun'
        >
          เนื่องจากมีโควตาอื่นที่กำลังใช้งานในช่วงเวลา เดียวกัน โดยมีร้านค้าและสินค้าโควตาซ้ำกัน
          กรุณาตรวจสอบโควตาที่มีอยู่
        </Text>
      </div>

      <Row justify='center'>
        <Col span={12} style={{ paddingRight: 5 }}>
          <Button
            typeButton='primary-light'
            title='ตรวจสอบโควตา'
            onClick={onSubmit}
            style={{ width: "100%" }}
          />
        </Col>
        <Col span={12} style={{ paddingLeft: 5 }}>
          <Button typeButton={"primary"} title='ปิด' style={{ width: "100%" }} onClick={onCancel} />
        </Col>
      </Row>
    </Modal>
  );
}

export default ModalCheckQuotaDup;
